<template>
  <div v-if="debugUsersSwitcherEnabled"
       class="fixed z-50 bottom-0 left-0 bg-blue-900 flex items-center"
       :class="{'right-0': isExpanded}">
    <button
        @click="toggleExpand"
        class="text-gray-100 focus:outline-none m-2">
      <svg
          class="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 6H20M4 12H20M4 18H11"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
      </svg>
    </button>
    <div v-if="isExpanded" class="w-full">
      <div class="flex items-center">
        <button class="text-white font-medium underline mx-2"
                @click="showFindUserModal = true">Find User</button>
        <button class="text-white font-medium underline mx-2"
                @click="showFavoriteUsersModal = true">Favorite Users</button>
      </div>
    </div>

    <FindUserModal v-if="showFindUserModal"
                   :favorites="favorites"
                   @close="showFindUserModal = false"
                   @choose="chooseUser"
                   @toggle-favorites="toggleFavorites"/>

    <FavoriteUsersModal v-if="showFavoriteUsersModal"
                   :favorites="favorites"
                   @close="showFavoriteUsersModal = false"
                   @choose="chooseUser"
                   @toggle-favorites="toggleFavorites"/>
  </div>
</template>
<script>
import FindUserModal from "./modals/FindUserModal"
import FavoriteUsersModal from "./modals/FavoriteUsersModal"
import debugApi from "../../../api/debug"

export default {
  components: {
    FindUserModal,
    FavoriteUsersModal,
  },
  data() {
    return {
      debugUsersSwitcherEnabled: false,
      isExpanded: false,
      favorites: [],

      showFindUserModal: false,
      showFavoriteUsersModal: false,
    }
  },
  created() {
    this.getDebugAccess()
    this.initDebugUsersSwitcher()
  },
  methods: {
    getDebugAccess() {
      debugApi.debugAccess().then(({data}) => {
        this.debugUsersSwitcherEnabled = data.access
      })
    },
    initDebugUsersSwitcher() {
      let storageData = JSON.parse(localStorage.getItem('debug-users-switcher'))
      if(storageData) {
        this.isExpanded = storageData.isExpanded
        this.favorites = storageData.favorites
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      this.setDebugUsersSwitcher()
    },
    setDebugUsersSwitcher() {
      localStorage.setItem('debug-users-switcher', JSON.stringify({
        isExpanded: this.isExpanded,
        favorites: this.favorites
      }))
    },
    chooseUser(user) {
      debugApi.debugSwitch({employee: user.id}).then(() => {
        // localStorage.setItem('accessToken', res.user.token)
        location.reload()
      })
    },
    toggleFavorites(user) {
      if (this.favorites.some(u => u.id === user.id)) {
        this.favorites = this.favorites.filter(u => u.id !== user.id)
      } else {
        this.favorites.push(user)
      }

      this.setDebugUsersSwitcher()
    }
  }
}
</script>